export default function DataTable({
  data,
  isDriver,
  onEdit,
  onDelete,
  onToggleBlock,
  onView
}) {
  return (
    <table className="data-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Mobile</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>
        {data.map(item => (
          <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.mobile}</td>
            <td>{item.firstName || "-"}</td>
            <td>{item.lastName || "-"}</td>
            <td>{item.email || "-"}</td>

            <td className="actions">
              {/* ✅ DETAILS BUTTON (ONLY FOR DRIVERS) */}
              {isDriver && (
                <button
                  className="btn info"
                  onClick={() => onView(item)}
                >
                  Details
                </button>
              )}

              <button className="btn edit" onClick={() => onEdit(item)}>
                Edit
              </button>

              <button className="btn delete" onClick={() => onDelete(item.id)}>
                Delete
              </button>

              <button
                className={`btn ${item.isBlocked ? "unblock" : "block"}`}
                onClick={() => onToggleBlock(item.id, !item.isBlocked)}
              >
                {item.isBlocked ? "Unblock" : "Block"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
